import { useQueryClient } from "@tanstack/react-query";

const useReactQueryCacheModifier = () => {
  const queryClient = useQueryClient();

  const infiniteQueryCacheModifier = (
    queryKey: string[],
    addedUpdatedItem: any, // eslint-disable-line
    action: "add" | "update" | "delete",
  ) => {
    queryClient.setQueryData(
      queryKey,
      (
        prev: any, // eslint-disable-line
      ) => {
        const updatedPages = prev.pages.map(
          (
            page: any, // eslint-disable-line
          ) => {
            let updatedItems;

            switch (action) {
              case "add":
                updatedItems = [addedUpdatedItem, ...page.items];
                break;

              case "update":
                updatedItems = page.items.map(
                  (
                    item: any, // eslint-disable-line
                  ) => {
                    return item.id === addedUpdatedItem.id
                      ? addedUpdatedItem
                      : item;
                  },
                );
                break;

              case "delete":
                updatedItems = page.items.filter(
                  (
                    item: any, // eslint-disable-line
                  ) => item.id !== addedUpdatedItem.id,
                );
                break;

              default:
                updatedItems = page.items;
            }

            return {
              ...page,
              items: updatedItems,
            };
          },
        );

        return {
          pages: updatedPages,
          pageParams: prev.pageParams,
        };
      },
    );
  };

  return {
    infiniteQueryCacheModifier,
  };
};

export default useReactQueryCacheModifier;
